import React, { ComponentProps, useEffect, useState } from "react";
import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonModal, IonTitle, IonToolbar } from "@ionic/react";
import { useCartData } from "../../providers/cartDataStore";
import UnavailableProductModalCard from "./UnavailableProductModalCard";
import useWindowSize from "../../utils/useWindowSize";
import classNames from "classnames/bind";
import styles from "./UnavailableProducts.module.scss";
import { closeCircleOutline } from "ionicons/icons";
import { useLocation } from "react-router";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

const UnavailableProductsModal = () => {
  const { t } = useTranslation();
  const { unavailableProducts, soldOutProducts } = useCartData();
  const [isOpen, setIsOpen] = useState(false);
  const { width, md } = useWindowSize();
  const widthLessThanMd = width < md;
  const location = useLocation();

  useEffect(() => {
    const isNotInCart = !location.pathname.includes("cart");

    if (unavailableProducts.length || soldOutProducts.length) {
      if (isNotInCart) {
        setIsOpen(true);
      }

      toast.warn(
        `${t("Cart has changed")}. \n
           ${t("The red crossed out number shows the previous quantity of the product in the basket")}.`,
        {
          autoClose: 8000,
        }
      );
    }
  }, [location.pathname, soldOutProducts, unavailableProducts]);

  const closeModal = () => {
    setIsOpen(false);
    // clearSoldOutProducts();
    // clearUnavailableProducts();
  };

  const smModalProps: ComponentProps<typeof IonModal> = widthLessThanMd
    ? {
        initialBreakpoint: 0.75,
        breakpoints: [0.5, 0.75, 1],
        className: cx("unavailable_products_modal"),
      }
    : {};

  return (
    <IonModal isOpen={isOpen} onDidDismiss={closeModal} backdropDismiss={true} {...smModalProps}>
      <IonHeader className="ion-no-border">
        <IonToolbar className="items-center h-16">
          <IonTitle className="text-sm">{t("Cart has changed")}</IonTitle>
          <IonButtons slot="end">
            <IonButton className="text-sm" onClick={closeModal}>
              <IonIcon icon={closeCircleOutline} color="#000" />
            </IonButton>
          </IonButtons>
        </IonToolbar>
        <div className="text-sm p-4 border-b text-black bg-white">
          {t("The red crossed out number shows the previous quantity of the product in the basket")}
        </div>
      </IonHeader>
      <IonContent className={cx(widthLessThanMd && "h-[85vh]", "ion-padding")}>
        {soldOutProducts.map((soldOutProduct) => (
          <UnavailableProductModalCard
            key={soldOutProduct.id}
            unavailableOrSoldOutProduct={soldOutProduct}
            message={t(soldOutProduct.stockQuantity < 1 ? "Sold out" : "Quantity has changed")}
          />
        ))}
        {unavailableProducts.map((unavailableProduct) => (
          <UnavailableProductModalCard
            isUnavailable={true}
            key={unavailableProduct.id}
            unavailableOrSoldOutProduct={unavailableProduct}
            message={t("Not available in your delivery area")}
          />
        ))}
      </IonContent>
    </IonModal>
  );
};

export default UnavailableProductsModal;
